import { Box, Theme, useMediaQuery } from "@material-ui/core";
import { createRef, FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import CenteredMessage from "../../../components/CenteredMessage";
import OnScroll from "../../../components/OnScroll";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { QueryDocumentSnapshot } from "../../../types/firebase.types";
import { ReduxState } from "../../../types/redux.types";
import { AppResource } from "../../../types/resource.types";
import { getChatRoomMessagesAction, loadMoreRoomMessagesAction } from "../redux/actions";
import { IChatParams, IMessages, IRooms } from "../type";
import chatQueries from "../utils/chatQueries";
import ChatActionContainer from "./ChatActionContainer";
import Messages from "./Messages";

const Chatting: FC = () => {
  const scrollRef = createRef();
  const { user } = useCurrentUser();
  const dispatch = useDispatch();
  const { roomId } = useParams<IChatParams>();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const messages = useSelector<ReduxState, IMessages[]>((state) => state.chat.messages[roomId]);
  const messagesLoading = useSelector<ReduxState, boolean>((state) => state.chat.loadingMessages);
  const rooms = useSelector<ReduxState, IRooms>((state) => state.chat.rooms);

  const handleLoadMoreMessages = () => {
    dispatch(
      loadMoreRoomMessagesAction({
        roomId,
        loadMoreRoomMessagesQuery: () =>
          chatQueries.loadMoreRoomMessages({
            startAfter: messages[messages.length - 1].snapshot as unknown as QueryDocumentSnapshot,
            roomId,
          }),
      })
    );
  };

  useEffect(() => {
    if (roomId !== AppResource.rooms)
      dispatch(
        getChatRoomMessagesAction({
          roomId,
          getRoomMessagesQuery: () => chatQueries.getRoomMessages({ roomId }),
        })
      );
  }, [roomId]);

  return (
    <>
      {messages && rooms[roomId] && roomId !== AppResource.rooms ? (
        <Box display="flex" flexDirection="column" height="inherit" px={1}>
          <Box flex={1} height="90%">
            <OnScroll onScrollTop={handleLoadMoreMessages} loading={messagesLoading} deps={[messages.length, roomId]}>
              <Messages messages={messages} roomId={roomId} lastMessageSeen={rooms[roomId].seenBy[user.id!]} />
            </OnScroll>
          </Box>
          <Box height="75px">
            <ChatActionContainer participants={rooms[roomId].participants} scrollRef={scrollRef} />
          </Box>
        </Box>
      ) : !isSm ? (
        <CenteredMessage message="Select chat to start." />
      ) : null}
    </>
  );
};

export default Chatting;
